export default "__VITE_ASSET__D9Caomvi__"